import { memberDirectoryPageConstant } from '../components/MemberDirectoryPage/memberDirectoryPage.constants';
import { ypoEventConstant } from "@/components/YpoEvents/ypoEvents.constant";

export const oktaAuthConfig = {
    clientId: process.env.VUE_APP_CLIENT_ID,
    redirectUri: window.location.origin,
    issuer: `${process.env.VUE_APP_OKTA_URL}oauth2/default`,
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true,
};

export const getDefaultAuthData = () => {
    return {
        authProvider: 'okta',
        token: null,
        tokenType: null,
        expTime: null,
        userGuid: null,
    };
};

export const erorrMessages = {
    login: {
        INVALID_USER_OR_PASSWORD: 'You have entered an invalid username or password. Please try again.',
        NOT_ASSIGNED_OKTA_APP:
            'This YPO Connect preview is currently in limited release but will be available soon to all YPOers. Please watch your inbox for more information.',
        EMAIL_NOT_FOUND: 'The email address, as entered, does not match our records.',
        PASSWORD_RESET_GENERIC_ERROR: `If you did not receive instructions to reset your password, please contact 
            <a href="mailto:ask@ypo.org?subject=Please reset my YPO password">ask@ypo.org</a>. 
            <p>We are happy to help you connect.</p>`,
        DETAILS_DONT_MATCH_ERROR: 'The Details do not match any user in database',
        INVALID_IDENTIFICATION_CODE: 'You have entered an invalid code.',
        PASSWORD_COMPLEXITY_REQUIREMENTS_MEET_ERROR:
            'The password does not meet the complexity requirements of the current password policy.',
        NEW_PASSOWRD_CANNOT_BE_THE_SAME_AS_YOUR_CURRENT_PASSWORD:
            'New password cannot be the same as your current password',
        PASSWORD_CANNOT_BE_YOUR_CURRENT_PASSWORD: 'Password cannot be your current password',
        UNABLE_TO_CONNECT_TO_THE_SERVER: 'Unable to connect to the serve',
    },
};

export const activityPostObject = () => {
    //TODO: check with API on what exactly to pass for Create Post
    return {
        title: '',
        body: '',
        postImage: [],
        parentPostId: '',
        communityId: '',
        canComment: true,
    };
};

export const featureEventObject = () => {
    return {
        title: '',
        subtitle: '',
        url: '',
        body: '',
        communityId: '',
        isImageOverLay: true,
        featuredPostImage: {},
        order: 0,
    };
};

export const additionalSecurityForMember = () => {
    return {
        birthDate: '',
        lastName: '',
        countryCode: '',
        phoneNumber: '',
    };
};

export const memberDirectorySearchObject = (searchText, searchOrder, searchKey, selectedFilters, skip) => {
    let selectedSearchFilters = [];
    if (selectedFilters) {
        Object.keys(selectedFilters).forEach((item) => {
            if (selectedFilters.hasOwnProperty(item) && item.length > 0) {
                selectedSearchFilters = [...selectedSearchFilters, ...selectedFilters[item]];
            }
        });
    }
    return {
        search: searchText && searchText.length > 1 ? searchText : '',
        orderBy: searchOrder,
        searchKey,
        searchFilters: selectedSearchFilters,
        skip,
        maxResultCount: memberDirectoryPageConstant.constant.searchResultMaxCount,
    };
};

export const defaultDirectorySearchObject = (searchText, searchOrder, selectedFilters, skip, searchMaxCount) => {
    let selectedSearchFilters = [];
    if (selectedFilters) {
        Object.keys(selectedFilters).forEach((item) => {
            if (selectedFilters.hasOwnProperty(item) && item.length > 0) {
                selectedSearchFilters = [...selectedSearchFilters, ...selectedFilters[item]];
            }
        });
    }
    return {
        search: searchText && searchText.length > 1 ? searchText : '',
        orderBy: searchOrder || '',
        searchFilters: selectedSearchFilters,
        skip: skip || 0,
        fieldToQuery: '',
        maxResultCount: searchMaxCount || 50,
    };
};

export const memberDirectoryTypeAheadObject = (
    searchText,
    originalSearchText,
    selectedTypeAhead,
    selectedFilters,
    additionalFilters,
    typeAheadAdditionalFilter,
) => {
    let selectedSearchFilters = [];
    if (selectedFilters) {
        Object.keys(selectedFilters).forEach((item) => {
            if (selectedFilters.hasOwnProperty(item) && item.length > 0) {
                selectedSearchFilters = [...selectedSearchFilters, ...selectedFilters[item]];
            }
        });
    }

    if (additionalFilters && additionalFilters.length) {
        selectedSearchFilters = [...selectedSearchFilters, ...additionalFilters];
    }
    return {
        search: searchText,
        originalSearch: originalSearchText && originalSearchText.length > 2 ? originalSearchText : '',
        fieldsToQuery: [selectedTypeAhead.key],
        searchFilters: selectedSearchFilters,
        ribbonGroupName: selectedTypeAhead.ribbonGroupName,
        typeaheadPreFilter: typeAheadAdditionalFilter || {},
    };
};

export const eventDirectoryTypeAheadObject = (
    searchText,
    originalSearchText,
    selectedTypeAhead,
    selectedFilters,
    additionalFilterToQuery,
) => {
    let selectedSearchFilters = [];
    if (selectedFilters) {
        Object.keys(selectedFilters).forEach((item) => {
            if (selectedFilters.hasOwnProperty(item) && item.length > 0) {
                selectedSearchFilters = [...selectedSearchFilters, ...selectedFilters[item]];
            }
        });
    }
    return {
        search: searchText,
        originalSearch: originalSearchText && originalSearchText.length > 2 ? originalSearchText : '',
        fieldsToQuery: [selectedTypeAhead.filterKey],
        searchFilters: selectedSearchFilters,
        typeaheadPreFilter: additionalFilterToQuery || {},
    };
};

export const getNavigatorBroswer = () => {
    let browser = ''; 
    const usrAg = navigator.userAgent;
    const navigatorPlatform = navigator.platform;

    // The order matters here, and this may report false positives for unlisted browsers.    
    if (usrAg.indexOf("Firefox") > -1) {
        browser = "Mozilla Firefox";
      // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    } else if (usrAg.indexOf("SamsungBrowser") > -1) {
        browser = "Samsung Internet";
      // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
    } else if (usrAg.indexOf("Opera") > -1 || usrAg.indexOf("OPR") > -1) {
        browser = "Opera";
      // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    } else if (usrAg.indexOf("Trident") > -1 || usrAg.indexOf("MSIE") > -1) {
        browser = "Microsoft Internet Explorer";
      // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if (usrAg.indexOf("Edge") > -1 || usrAg.indexOf("Edg") > -1) {
        browser = "Microsoft Edge";
      // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299 /Edg/88.0.705.81 "
    } else if (usrAg.indexOf("Chrome") > -1) {
        browser = "Google Chrome";
      // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
    } else if (usrAg.indexOf("Safari") > -1) {
        browser = "Apple Safari";
      // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    } else {
        browser = "unknown";
    }    
    
    return `${navigatorPlatform}_${browser}`;
};

export const eventDirectorySearchObject = (searchText, searchOrder, selectedFilters, skip, userRegisteredAndWaitlistedEventCount) => {
    let selectedSearchFilters = [];
    if (selectedFilters) {
        Object.keys(selectedFilters).forEach((item) => {
            if (selectedFilters.hasOwnProperty(item) && item.length > 0) {
                selectedSearchFilters = [...selectedSearchFilters, ...selectedFilters[item]];
            }
        });
    }    
    const browserName = getNavigatorBroswer();
    return {
        search: searchText && searchText.length > 1 ? searchText : '',
        orderBy: searchOrder || '',
        searchFilters: selectedSearchFilters,
        skip: skip || 0,
        fieldToQuery: '',
        maxResultCount: ypoEventConstant.constant.searchResultMaxCount,
        isChampEvents: false,
        platformName: browserName,
        userRegisteredAndWaitlistedEventCount: userRegisteredAndWaitlistedEventCount || 0,
    };
};

export const contentDirectorySearchObject = (searchText, searchOrder, selectedFilters, skip) => {
    let selectedSearchFilters = [];
    if (selectedFilters) {
        Object.keys(selectedFilters).forEach((item) => {
            if (selectedFilters.hasOwnProperty(item) && item.length > 0) {
                selectedSearchFilters = [...selectedSearchFilters, ...selectedFilters[item]];
            }
        });
    }
    return {
        search: searchText && searchText.length > 1 ? searchText : '',
        orderBy: searchOrder || '',
        searchFilters: selectedSearchFilters,
        skip: skip || 0,
        fieldToQuery: '',
        maxResultCount: contentDirectoryPageConstant.constant.searchResultMaxCount,
    };
};

export const forumUserInfo = {
    username: 'antonio_n_valle',
    password: 'ypot3st',
    clientId: 'precocity_llc',
    clientSecret: '2uXavWC5ImP2FX8gD5IDXZOTXcLtuUsiID+GY2OJVrE=',
    scope: 'https://precocityllc.com',
};
